<template>
  <div v-if="visible" class="guide-mask">

    <div class="guide-dialog">

      <!-- Header -->
      <div class="guide-header">
        <div class="guide-title">
          <div class="guide-title-main">
            扫码操作指引（幻影分身）
          </div>

          <div class="guide-title-sub">
            准备两部设备，改好位置的手机扫码，另一部设备打开该页面！
          </div>
        </div>

        <div class="guide-header-right">
          <span class="guide-count">
            {{ currentIndex + 1 }}/{{ steps.length }}
          </span>

          <van-icon
            name="cross"
            class="guide-close"
            @click="handleSkip"
          />
        </div>
      </div>

      <!-- Image -->
      <div class="guide-body">
        <van-swipe
          ref="swipe"
          :loop="false"
          :show-indicators="false"
          class="guide-swipe"
          @change="onChange"
        >
          <van-swipe-item
            v-for="(item, index) in steps"
            :key="index"
            class="swipe-item"
          >
            <div class="img-wrap">
              <img
                :src="item.image"
                class="guide-image"
                @click="preview(item.image)"
              />
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>

      <!-- dots -->
      <div class="guide-dots">
        <span
          v-for="(s, i) in steps"
          :key="i"
          class="dot"
          :class="{ active: i === currentIndex }"
        />
      </div>

      <!-- footer -->
      <div class="guide-footer">

        <template v-if="currentIndex !== steps.length - 1">

          <van-button plain size="small" @click="handleSkip">
            跳过
          </van-button>

          <van-button
            plain
            size="small"
            :disabled="currentIndex === 0"
            @click="prev"
          >
            上一步
          </van-button>

          <van-button type="primary" size="small" @click="next">
            下一步
          </van-button>

        </template>

        <template v-else>

          <van-button plain size="small" @click="handleSkip">
            跳过
          </van-button>

          <van-button
            type="primary"
            block
            class="start-btn"
            @click="finishGuide"
          >
            我已知晓
          </van-button>

        </template>

      </div>

    </div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant';

const KEY = 'scan_guide_read_time';
const EXPIRE = 30 * 60 * 1000;

export default {
  name: 'GuideStepsDialog',

  props: {
    visible: Boolean,
  },

  data() {
    return {
      currentIndex: 0,

      steps: [
        { image: require('@/assets/yd-page/yd1.jpg') },
        { image: require('@/assets/yd-page/yd2.jpg') },
        { image: require('@/assets/yd-page/yd3.jpg') },
        { image: require('@/assets/yd-page/yd4.jpg') },
        { image: require('@/assets/yd-page/yd5.jpg') },
        { image: require('@/assets/yd-page/yd6.jpg') },
      ],
    };
  },

  methods: {

    onChange(i) {
      this.currentIndex = i;
    },

    next() {
      if (this.currentIndex < this.steps.length - 1) {
        this.currentIndex++;
        this.$refs.swipe.swipeTo(this.currentIndex);
      }
    },

    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.$refs.swipe.swipeTo(this.currentIndex);
      }
    },

    preview(img) {
      ImagePreview([img]);
    },

    handleSkip() {
      this.$emit('close');
    },

    finishGuide() {
      localStorage.setItem(KEY, Date.now().toString());
      this.$emit('acknowledge');
    },
  },
};
</script>

<style scoped>

/* 遮罩 */
.guide-mask {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0,0,0,.6);
  padding: 25px;
}

/* 弹窗主体 */
.guide-dialog {
  width: min(1100px, 96vw);
  height: min(92vh, 900px);
  background: #fff;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* header */
.guide-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  border-bottom: 1px solid #f2f3f5;
}

/* 标题整体容器 */
.guide-title {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* 主标题 */
.guide-title-main {
  font-size: 18px;
  font-weight: 700;
  color: #1f2329;
  line-height: 1.3;
  letter-spacing: 0.2px;
}

/* 副标题（说明文字） */
.guide-title-sub {
  font-size: 13px;
  font-weight: 600;
  color: #ec3729;
  line-height: 1.5;

  /* 控制最长两行，避免PC撑爆 */
  max-width: 720px;
  word-break: break-word;
}

/* ===== PC优化 ===== */
@media (min-width: 769px) {

  .guide-title-main {
    font-size: 20px;
  }

  .guide-title-sub {
    font-size: 14px;
  }
}

/* ===== 移动端优化（微信重点） ===== */
@media (max-width: 768px) {

  .guide-title-main {
    font-size: 16px;
  }

  .guide-title-sub {
    font-size: 12px;
    line-height: 1.4;

    /* 防止占用过多头部高度 */
    max-width: 100%;
  }
}

.guide-header-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.guide-count {
  color: #1989fa;
  font-weight: 600;
}

.guide-close {
  font-size: 18px;
}

/* body */
.guide-body {
  flex: 1;
  min-height: 0;
  padding: 10px;
}

.guide-swipe {
  height: 100%;
}

.swipe-item {
  height: 100%;
}

/* 图片区域（关键修复） */
.img-wrap {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7f8fa;
  border-radius: 12px;
}

/* 图片完整显示（核心修复点） */
.guide-image {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
}

/* dots */
.guide-dots {
  display: flex;
  justify-content: center;
  gap: 6px;
  padding: 10px 0;
  background: #fafafa;
}

.dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #dcdfe6;
  transition: .2s;
}

.dot.active {
  width: 18px;
  border-radius: 999px;
  background: #1989fa;
}

/* footer */
.guide-footer {
  padding: 12px;
  border-top: 1px solid #f2f3f5;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
}

.start-btn {
  flex: 1;
  margin-top: 6px;
}

/* mobile */
@media (max-width: 768px) {

  .guide-dialog {
    width: 100%;
    height: calc(100vh - 100px);
    border-radius: 12px;
  }

  .guide-title {
    font-size: 16px;
  }

  .guide-footer {
    flex-wrap: wrap;
  }

  .guide-footer .van-button {
    flex: 1;
  }
}
</style>
